import React from "react";
import { SITE } from "../config/site";
import { NAV_FOOTER_COMPANY, NAV_FOOTER_PRODUCT, NAV_LEGAL } from "../config/navigation";
import Link from "../components/Link";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-ink/8 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <img src="/images/StratifyLogo.png" alt="" className="h-7 w-7 rounded-lg object-contain" />
              <span className="text-sm font-semibold tracking-tight text-ink">Stratify</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted">
              {SITE.description}
            </p>
            <a
              href={SITE.appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center rounded-full bg-ink px-4 py-2.5 text-sm font-semibold text-white"
            >
              Get Stratify for iPhone
            </a>
          </div>

          <div className="grid gap-8 sm:grid-cols-3 md:col-span-7">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">Product</p>
              <nav aria-label="Product" className="mt-3 flex flex-col gap-2">
                {NAV_FOOTER_PRODUCT.map((item) => (
                  <Link key={item.key} to={item.href} className="inline-flex min-h-10 items-center text-sm text-ink/75 hover:text-ink">
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">Company</p>
              <nav aria-label="Company" className="mt-3 flex flex-col gap-2">
                {NAV_FOOTER_COMPANY.map((item) => (
                  <Link key={item.key} to={item.href} className="inline-flex min-h-10 items-center text-sm text-ink/75 hover:text-ink">
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">Legal</p>
              <nav aria-label="Legal" className="mt-3 flex flex-col gap-2">
                {NAV_LEGAL.map((item) => (
                  <Link
                    key={item.key}
                    to={item.href}
                    className="inline-flex min-h-10 items-center text-sm text-ink/75 underline-offset-4 hover:text-hint-deep hover:underline"
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-ink/8 pt-6 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-muted">© 2026 Stratify Analytics Inc. All rights reserved.</p>
          <p className="text-xs text-muted">Not financial advice. Educational purposes only.</p>
        </div>
      </div>
    </footer>
  );
}
